import local from "./local.json";
import development from "./dev.json";
import production from "./production.json";
import preprod from "./preprod.json";
import sandbox from "./sandbox.json";
import qa from "./qa.json";
import { Config } from "./configuration";

const hostname = window && window.location && window.location.hostname;
let configuration: Config = new Config();
switch (hostname) {
  case "localhost":
    configuration = local.configuration;
    break;
  case "academics-dev.progresslearning.com":
    configuration = development.configuration;
    break;
  case "academics.progresslearning.com":
    configuration = production.configuration;
    break;
  case "academics-preprod.progresslearning.com":
    configuration = preprod.configuration;
    break;
  case "academics-sandbox.progresslearning.com":
    configuration = sandbox.configuration;
    break;
  case "academics-qa.progresslearning.com":
    configuration = qa.configuration;
    break;
  default:
    configuration = development.configuration;
}

export const Configuration = configuration;
